import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'calendar',
  children: {
    calendar: {
      path: '',
      size: 'full',
    },
    leaves: {
      path: 'leaves',
      children: {
        editLeave: {
          path: 'edit/:leave_id',
          size: 'full',
        },
        rejectLeave: {
          path: 'reject/:leave_id',
          size: 'full',
        },
      },
    },
    teamView: {
      size: 'full',
      path: 'team-view',
      children: {
        leavesEditLeaveId: {
          size: 'full',
          path: 'leaves/edit/:leave_id',
        },
        leavesRejectLeaveId: {
          size: 'full',
          path: 'leaves/reject/:leave_id',
        },
      },
    },
    bulkAddTimeOff: {
      size: 'full',
      path: 'bulk-add-time-off',
    },
  },
} as const satisfies Location
